interface EducationLevelProps {
	educationLevelList: Array<{ name: string }>;
}

export const EducationLevel = ({ educationLevelList }: EducationLevelProps) => {
	if (!educationLevelList?.length) return null;

	return (
		<div className="education-level">
			<h2 className="section-title">Kademe Bilgisi</h2>
			<div className="education-tags">
				{educationLevelList.map((level, index) => (
					<span
						key={index}
						className="tag">
						{level.name}
					</span>
				))}
			</div>
		</div>
	);
};
